import type { WorkspaceRole } from '@/lib/settings';

import type { SettingsSection } from '@/features/settings/search-schema';
import { capitalize } from '@/lib/string';

/**
 * Pure helpers backing the Sidebar. Kept out of the `.tsx` files so those stay
 * component-only modules (Vite Fast-Refresh rule — see apps/web/CLAUDE.md
 * "component-only `.tsx`").
 */

/**
 * Display label for the role — the capitalized role, or `null` when there's
 * nothing to show. `owner` comes through the workspace role like every other
 * value.
 */
export function roleBadgeLabel(workspaceRole: WorkspaceRole | null): string | null {
  if (!workspaceRole) return null;
  return capitalize(workspaceRole);
}

/** Settings section the user row links into. */
export const PROFILE_SETTINGS_SECTION: SettingsSection = 'profile';

/**
 * A nav count badge's text: nothing for zero/unknown, `"9+"` past `cap`, and a
 * trailing `+` when the server says the count is only a lower bound
 * (action items' `truncated` scan).
 */
export function navCountLabel(
  count: number | null | undefined,
  { cap = 99, lowerBound = false }: { cap?: number; lowerBound?: boolean } = {},
): string | undefined {
  if (!count || count <= 0) return undefined;
  if (count > cap) return `${cap}+`;
  return lowerBound ? `${count}+` : String(count);
}
